import React from 'react';
import {
  Box, MultiSelectComponents,
} from '@usealloy/component-library';
import type { OptionProps } from '@usealloy/component-library';
import type { AxisHeaderActionOption as AxisHeaderOptionType } from '../types';
import { StyledText } from './styles';

interface AxisHeaderOptionProps extends OptionProps<AxisHeaderOptionType, false> { }
export default function AxisHeaderActionOption(props: AxisHeaderOptionProps) {
  const {
    data: {
      label,
      meta: {
        color,
        name,
      } = {},
    },
  } = props;

  return (
    <MultiSelectComponents.Option {...props}>
      <Box justifyContent="flex-start">
        <StyledText>{`${label}: `}</StyledText>
        <StyledText color={color}>{name}</StyledText>
      </Box>
    </MultiSelectComponents.Option>
  );
}
